<template>
  <div class="flex flex-col gap-y-2">
    <div v-if="title" :class="headingClasses" class="font-bold">
      {{ title }}
    </div>
    <div
      v-if="renderedBodyText"
      class="rich-text-content text-body-md"
      v-html="renderedBodyText"
    ></div>
  </div>
</template>

<script>
import { convertStoryblokRichTextToHtml } from '@/utils/storyblokRichText';
import { getHeadingClasses } from '@/utils/eventPageHeading';

export default {
  name: 'EventRichTextBlock',
  props: {
    title: {
      type: String,
      default: '',
    },
    headingSize: {
      type: String,
      default: 'H2',
    },
    bodyText: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    headingClasses() {
      return getHeadingClasses(this.headingSize);
    },
    renderedBodyText() {
      return convertStoryblokRichTextToHtml(this.bodyText);
    },
  },
};
</script>

<style scoped>
.rich-text-content :deep(ul) {
  list-style-type: disc;
  padding-left: 1.25rem;
  margin: 0.75rem 0;
}

.rich-text-content :deep(ol) {
  list-style-type: decimal;
  padding-left: 1.25rem;
  margin: 0.75rem 0;
}

.rich-text-content :deep(li) {
  display: list-item;
  margin: 0.25rem 0;
}

.rich-text-content :deep(p) {
  margin: 0.5rem 0;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: none;
}

.rich-text-content :deep(li > p) {
  margin: 0;
}
</style>
